import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpInterceptorsModule} from './core/interceptors/http-interceptors.module';
import {TranslateConfigurationModule} from './core/translate-configuration/translate-configuration.module';
import {MatomoInitializationMode, NgxMatomoModule} from 'ngx-matomo-client';
import {MatomoProvider} from './core/matomo-configuration/matomo-provider.service';
import {UiConfigService} from './services/ui-config.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpInterceptorsModule,
    TranslateConfigurationModule,
    NgxMatomoModule.forRoot({
      mode: MatomoInitializationMode.AUTO_DEFERRED
    })
  ],
  bootstrap: [
    AppComponent,
  ],
  providers: [
    MatomoProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: (svc: UiConfigService) => () => svc.init(),
      deps: [UiConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (provider: MatomoProvider) => () => provider.init(),
      deps: [MatomoProvider],
      multi: true,
    }
  ],
})
export class AppModule {
}
